<template>
  <div class="news page-shell">
    <banner
      title="新闻资讯"
      eyebrow="News Center"
      desc="关注宇飞智能在智慧停车、智能交通和云端通行管理领域的最新动态与行业荣誉。"
    />

    <section class="section-wrap news-section">
      <div class="section-head">
        <div>
          <p class="section-kicker">LATEST NEWS</p>
          <h2 class="section-title">企业动态与行业认可</h2>
        </div>
        <p class="section-desc">沉淀项目经验，持续升级智慧通行产品和运营服务。</p>
      </div>

      <div class="news-grid">
        <router-link
          v-for="item in newsList"
          :key="item.id + item.title"
          class="news-card"
          :to="{ name: 'newsdetails', params: item }"
        >
          <img v-lazy="item.Img" :alt="item.title" />
          <div class="news-card__body">
            <span>{{ item.CreateTime }}</span>
            <h3>{{ item.title }}</h3>
            <p>{{ item.content }}</p>
            <strong>阅读全文</strong>
          </div>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import site from "../static/siteData";

export default {
  name: "News",
  components: {
    Banner
  },
  data() {
    return {
      newsList: site.news
    };
  }
};
</script>

<style lang="scss" scoped>
.news-section {
  padding: 76px 0 92px;
}

.section-head {
  margin-bottom: 34px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 36px;
}

.section-desc {
  max-width: 430px;
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
}

.news-card {
  overflow: hidden;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 18px 50px rgba(16, 68, 130, 0.08);
  transition: transform 0.22s ease, box-shadow 0.22s ease;
}

.news-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 70px rgba(16, 68, 130, 0.14);
}

.news-card img {
  width: 100%;
  height: 190px;
  display: block;
  object-fit: cover;
  background: #eaf5ff;
}

.news-card__body {
  padding: 22px;
}

.news-card span {
  color: #1677ff;
  font-size: 13px;
  font-weight: 900;
}

.news-card h3 {
  min-height: 54px;
  margin-top: 10px;
  color: #071a35;
  font-size: 20px;
  line-height: 1.35;
}

.news-card p {
  min-height: 76px;
  margin-top: 12px;
  color: #64748b;
  font-size: 14px;
  line-height: 1.8;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.news-card strong {
  display: inline-block;
  margin-top: 18px;
  color: #1677ff;
  font-size: 14px;
}

@media (max-width: 1080px) {
  .news-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .news-section {
    padding: 56px 0 70px;
  }

  .section-head {
    align-items: flex-start;
    flex-direction: column;
  }

  .news-grid {
    grid-template-columns: 1fr;
  }
}
</style>
